<template>
    <el-dialog :show-close="false" class="suleymanCakir" :custom-class="'user-dialog'" :visible="dialogvisible"
               width="50%"
               @close="$emit('update:dialogvisible', false); visiblePassword=false">

        <div class="avatar-box">
            <img :src="imagePlaceholder"
                 alt="user avatar">
            <div class="text-center margin-top-25 font-weight-600" style="font-size: 16px !important;">{{this.isimBilgisi}}</div>
        </div>
        <div v-for="(item,index) in surecList" :key="item.index">
            <el-col :lg="24" :md="24" :sm="24" :xs="24" style="background: #f4f7fa; color: #303133">
                <el-row v-if="surecList[index-1]">
                    <el-col v-if="surecList[index].tarih2 !== surecList[index-1].tarih2" :lg="12" :md="12" :sm="12" :xs="12" class="col-pad gun-bilgisi">
                        {{item.tarih2}} - {{item.gun}}
                    </el-col>
                    <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-pad gun-bilgisi text-right"></el-col>
                </el-row>
                <el-row v-else-if="!surecList[index-1]">
                    <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-pad gun-bilgisi">
                        {{item.tarih2}} - {{item.gun}}
                    </el-col>
                    <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-pad gun-bilgisi text-right"></el-col>
                </el-row>
            </el-col>
            <el-col :lg="24" :md="24" :sm="24" :xs="24" style="background: #fff; color: #303133">
                <el-row>
                    <el-col :lg="2" :md="2" :sm="2" :xs="2" class="col-pad">
                        {{item.saat}}
                    </el-col>
                    <el-col :lg="1" :md="1" :sm="1" :xs="1" class="col-pad">
                        <i v-if="item.tipi === 'Cerrahi Uygulama'" style="color: #3cbcb4" class="mdi mdi-brightness-1"></i>
                        <i v-else style="color: #161c3c" class="mdi mdi-brightness-1"></i>
                    </el-col>
                    <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-pad">
                        <span v-if="item.tipi === 'Cerrahi Uygulama'" style="cursor: pointer" v-on:click="eventClick(item)">{{item.tipi}}</span>
                        <span v-else style="cursor: pointer" v-on:click="eventClick(item)">{{item.tipi}}</span>
                    </el-col>
                </el-row>
            </el-col>
        </div>
        <!--<randevu-ekle v-if="dialogVisibleRandevu" :dialogvisible.sync="dialogVisibleRandevu" :randevuId="randevuId"-->
                      <!--:hastaId="hastaId" :hekimId="hekimId" :hekimVisible="hekimVisible" :hastadata="hastadata"></randevu-ekle>-->
    </el-dialog>

</template>

<script>
    import hastaService from '../WSProvider/HastaService'
    import EventBus from '@/components/event-bus'
    // import RandevuEkle from '@/components/RandevuEkle'
    import notification from '../notification'
    import functions from '../functions'


    export default {
        name: 'HastaSurecDetay',
        // watch: {
        //     hekimVisible: function (val) {
        //         console.log(val)
        //     }
        // },
        props: ['userdata', 'dialogvisible'],
        // components: {
        //     RandevuEkle
        // },
        data() {
            return {
                hastadata : this.userdata,
                isimBilgisi: '',
                hastaId: '',
                hekimId: '',
                randevuId : '',
                uygulamaTarihId : '',
                dialogVisibleRandevu: false,
                dialogVisible: false,
                hekimVisible : false,

                surecList: [],
                imagePlaceholder: 'data:image/jpeg;base64,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',
            }
        },
        mounted() {
            this.surecDetay();
            let self = this;
            EventBus.$on('randevuList', function (bool) {
                if (bool) {
                    self.events = [];
                    self.surecDetay();
                }
            });
        },
        methods: {
            surecDetay() {
                let self = this;
                hastaService.detayList(this.userdata.hastaId).then((response) => {
                    if (response.status === 200) {
                        this.isimBilgisi=response.data[0].adSoyad
                        response.data.forEach(function (e) {
                            if(e.uygulamaTarihId){
                                e.tipi = "Cerrahi Uygulama"
                            }else if(e.randevuTarihId){
                                e.tipi = e.randevuSayisi +  ". Randevu"
                            }
                            var saat = e.tarih.split(' ')[1];
                            e.tarih2 = e.tarih.split(' ')[0];
                            e.saat = saat.split(':')[0]+':'+saat.split(':')[1];
                            let date = new Date(e.tarih);
                            switch (date.getDay()) {
                                case 0 : e.gun = "Pazar"; break;
                                case 1 : e.gun = "Pazartesi"; break;
                                case 2 : e.gun = "Salı"; break;
                                case 3 : e.gun = "Çarşamba"; break;
                                case 4 : e.gun = "Perşembe"; break;
                                case 5 : e.gun = "Cuma"; break;
                                case 6 : e.gun = "Cumartesi"; break;
                            }
                        });
                        this.surecList = (_.sortBy(response.data, 'tarih2'));
                    }
                });
            },
            eventClick(arg) {
                if (arg.randevuTarihId) {
                    this.dialogvisible = false;
                    this.route('Randevu Güncelleme',arg.randevuTarihId);
                }else if(arg.uygulamaTarihId){
                    this.dialogvisible = false;
                    this.route('Cerrahi Güncelleme',arg.uygulamaTarihId);
                }
            },
            route(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope);
                }
                var header = functions.linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },


        }

    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables';
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import '~@fullcalendar/timegrid/main.css';
    @import '~@fullcalendar/list/main.css';

    /*.page-calendar {
        .calendar-wrap {
            //background: white;
        }
    }*/
</style>

<style scoped>
    .avatar-box img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        position: relative;
        bottom: -20px !important;
        display: block;
        margin: 0 auto;
        background: white;
        border: 2px solid #0075c3;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .suleymanCakir .el-dialog__body {
        padding: 0;
    }

    .suleymanCakir .el-dialog__header {
        padding: 0;
    }

    .suleymanCakir .avatar-box {
        background: url("../assets/images/1596.jpg") center;
        background-size: cover;
        height: 150px;
        position: relative;
        margin: 0 !important;
    }
</style>